import { render, staticRenderFns } from "./categoryIng-modal.vue?vue&type=template&id=3aa4f6e7&"
import script from "./categoryIng-modal.vue?vue&type=script&lang=js&"
export * from "./categoryIng-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports